import React, { Component } from "react";
import LachakToranjTabItems from "./rugPartsTabs/lachakToranj";
import AfshanTabItems from "./rugPartsTabs/afshan";
import KheshtiTabItems from "./rugPartsTabs/kheshti";
import ModernTabItems from "./rugPartsTabs/modern";

export default class RugPartsPanelTabs extends Component {
  render() {
    const { stepOnboarding } = this.props;

    switch (this.props.globalState.activeCarpetType) {
      case "lachak-toranj":
        return (
          <LachakToranjTabItems
            stepOnboarding={stepOnboarding}
            texts={this.props.texts}
            activePartsTab={this.props.globalState.activePartsTab}
            partsTabHandler={this.props.partsTabHandler}
            themeDirection={this.props.themeDirection}
          />
        );
      case "afshan":
        return (
          <AfshanTabItems
            stepOnboarding={stepOnboarding}
            texts={this.props.texts}
            activePartsTab={this.props.globalState.activePartsTab}
            partsTabHandler={this.props.partsTabHandler}
            themeDirection={this.props.themeDirection}
          />
        );
      case "kheshti":
        return (
          <KheshtiTabItems
            stepOnboarding={stepOnboarding}
            texts={this.props.texts}
            activePartsTab={this.props.globalState.activePartsTab}
            partsTabHandler={this.props.partsTabHandler}
            themeDirection={this.props.themeDirection}
          />
        );
      case "modern":
        return (
          <ModernTabItems
            stepOnboarding={stepOnboarding}
            texts={this.props.texts}
            activePartsTab={this.props.globalState.activePartsTab}
            partsTabHandler={this.props.partsTabHandler}
            themeDirection={this.props.themeDirection}
          />
        );
      default:
        break;
    }
  }
}
